module.exports = __webpack_public_path__ + "img/pic_ocean_S.d3b16cee.jpg";